import AmountTransferForm from './AmountTransferForm'

export default AmountTransferForm
